$(function() {

    $(document).on('click', '.js-data-layer-event__add-to-cart--product-grid-item', (e) => {
        let items = [];
        let dataset = e.currentTarget.dataset;

        if (window && window.cbtag && dataset.layerVariantId) {
            console.log('cbtag add_to_cart', dataset.layerVariantId);
            window.cbtag('add_to_cart', {
                sku: dataset.layerVariantId,
            });
        }

        let inputCounterId = `#js-product-grid-item-input-counter--${dataset.layerItemId}`
        let itemQuantity = $(inputCounterId).val()

        let itemSchema = {
            'currency': dataset.layerCurrency,
            'item_brand': dataset.layerItemBrand,
            'item_id': dataset.layerItemId,
            'item_name': dataset.layerItemName,
            'item_variant': dataset.layerItemVariant,
            'item_variant_id': dataset.layerVariantId,
            'price': dataset.layerPrice,
            'quantity': itemQuantity,
            'sku': dataset.layerSku,
        }

        var productCollectionsNoLineBreaks = dataset.layerProductCollections.replace(/\r?\n|\r/g, '');

        let productCollections = JSON.parse(productCollectionsNoLineBreaks)

        let itemOutOfStock = false

        if (dataset.itemOutOfStock) {
            itemOutOfStock = dataset.itemOutOfStock
        }

        let item = dataLayerItem(itemSchema, itemOutOfStock, productCollections)

        items.push(item)

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                affiliation: 'shopify',
                coupon: 'null',
                currency: 'USD',
                items: items,
                value: itemSchema.price
            }
        })
    })

    $(document).on('click', '.js-data-layer-event__remove-from-cart', (e) => {
        let items = []
        let dataset = e.currentTarget.dataset;

        if (window && window.cbtag && dataset.layerVariantId) {
            console.log('cbtag remove_from_cart', dataset.layerVariantId);
            window.cbtag('remove_from_cart', {
                sku: dataset.layerVariantId,
            });
        }

        let itemSchema = {
            'currency': dataset.layerCurrency,
            'item_brand': dataset.layerItemBrand,
            'item_id': dataset.layerItemId,
            'item_name': dataset.layerItemName,
            'item_variant': dataset.layerItemVariant,
            'price': dataset.layerPrice,
            'quantity': dataset.layerQuantity,
            'sku': dataset.layerSku,
        }

        if (!dataset.productCollections) return;
        let productCollections = JSON.parse(dataset.productCollections)

        let itemOutOfStock = false

        if (dataset.itemOutOfStock) {
            itemOutOfStock = dataset.itemOutOfStock
        }

        let item = dataLayerItem(itemSchema, itemOutOfStock, productCollections)

        items.push(item)

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
                affiliation: 'shopify',
                coupon: 'null',
                currency: 'USD',
                items: items,
                value: itemSchema.price
            }
        })
    })

    $(document).on('click', '.js-data-layer-event__remove-from-cart--clear-cart', (e) => {
        let items = []
        let dataset = e.currentTarget.dataset
        let cartEndpoint = window.Shopify.routes.root + 'cart.js'
        jQuery.ajax({
            url: cartEndpoint,
            type: 'GET',
            success: function(data) {
                let items = JSON.parse(data).items.map(item => {
                    let itemPrice = item.price * 0.01
                    itemPrice = itemPrice.toFixed(2)
                    let itemSchema = {
                        'currency': 'USD',
                        'item_brand': 'Mothers Polish',
                        'item_id': item.product_id,
                        'item_name': item.title,
                        'item_variant': item.variant_title,
                        'item_variant_id': item.variant_id,
                        'item_out_of_stock': false,
                        'price': itemPrice,
                        'quantity': item.quantity,
                        'sku': item.sku,
                    }
                    return itemSchema
                })
                let itemsSubtotalPrice = JSON.parse(data).items_subtotal_price * 0.01
                itemsSubtotalPrice = itemsSubtotalPrice.toFixed(2)
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'remove_from_cart',
                    ecommerce: {
                        affiliation: 'shopify',
                        coupon: 'null',
                        currency: 'USD',
                        items: items,
                        value: itemsSubtotalPrice
                    }
                })

                if (window && window.cbtag) {
                    items.forEach(item => {
                        console.log('cbtag remove_from_cart', item.item_variant_id);
                        window.cbtag('remove_from_cart', {
                            sku: item.item_variant_id,
                        });
                    });
                }
            },
            error: function() {
                console.log('Quick view error')
            },
        })
    })

    $(document).on('click', '.js-data-layer-event__select-item', (e) => {
        let items = []
        let dataset = e.currentTarget.dataset

        let itemListName = dataset.layerItemListName
        let itemListId = dataset.layerItemListName.replace(' ', '_')

        let itemSchema = {
            'currency': dataset.layerCurrency,
            'item_brand': dataset.layerItemBrand,
            'item_id': dataset.layerItemId,
            'item_name': dataset.layerItemName,
            'item_variant': dataset.layerItemVariant,
            'price': dataset.layerPrice,
            'quantity': 1,
            'sku': dataset.layerSku,
            'item_list_name': dataset.layerItemListName,
        }



        var productCollectionsNoLineBreaks = dataset.layerProductCollections.replace(/\r?\n|\r/g, "");

        let productCollections = JSON.parse(productCollectionsNoLineBreaks)
        // let productCollections = JSON.parse(dataset.productCollections)

        let itemOutOfStock = false

        if (dataset.itemOutOfStock) {
            itemOutOfStock = dataset.itemOutOfStock
        }

        let item = dataLayerItem(itemSchema, itemOutOfStock, productCollections)

        items.push(item)

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "select_item",
            ecommerce: {
            item_list_id: itemListId,
            item_list_name: itemListName,
            items: items
            }
        })
    })

    $(document).on('click', '.js-data-layer-event__logout', (e) => {

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
        dataLayer.push({
            event: 'logout',
            userModel: {
                login_status: false
            }
        })
    })

    $('.js-data-layer-event__form-submit').on('submit', (e) => {
        let dataset = e.currentTarget.dataset

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
        dataLayer.push({
          event: 'form_submit',
          eventModel: {
            form_id: dataset.layerFormId,
            form_name: dataset.layerFormName,
            form_destination: dataset.layerFormDestination,
            form_submit_text: dataset.layerFormSubmitText,
            form_type: dataset.layerFormType
          }
        });
    })
})

/*
"(.*)"
dataset.$1
*/